import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Configure Stimulus development experience
application.debug = false;
window.Stimulus = application;

// make sure the turbo progress bar doesn't get stuck
let clearProgressTimeout;

addEventListener("turbo:frame-load", () => {
  if (!clearProgressTimeout) return;
  clearTimeout(clearProgressTimeout);
  clearProgressTimeout = undefined;
});
addEventListener("turbo:before-stream-render", (event) => {
  console.log("turbo:before-stream-render", event);
  clearProgressTimeout = setTimeout(() => {
    const progBar = document.querySelector(".turbo-progress-bar");
    if (progBar) progBar.style.opacity = "0";
  }, 500);
});

export { application };
